import React, { Component } from 'react';
import { OpeningBalanceSetup } from '../OpeningBalanceSetup';
import { OpeningCashBalance } from '../OpeningCashBalance';
import './styles.scoped.scss';

class OpeningBalances extends Component {
  render() {
    return (
      <div className="opening-balances-container">
        <div className="balance-section">
          <OpeningBalanceSetup />
        </div>
        <div className="balance-section">
          <OpeningCashBalance />
        </div>
      </div>
    );
  }
}

export { OpeningBalances };
